import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SmokeEffect from '../../components/base/SmokeEffect';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5ubj81r44f5krorkmgg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      <SmokeEffect />
      <Navbar />

      <section className="relative pt-28 sm:pt-32 pb-16 sm:pb-20 md:pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h1 className="font-orbitron text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-purple to-neon-pink mb-3 sm:mb-4 px-4">
              Get In Touch
            </h1>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Have questions? We'd love to hear from you
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12">
            <div className="space-y-6 sm:space-y-8">
              <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 sm:p-8 border border-neon-purple/30">
                <h2 className="font-orbitron text-xl sm:text-2xl font-bold text-neon-purple mb-4 sm:mb-6">
                  Contact Information
                </h2>
                <div className="space-y-4 sm:space-y-6 font-rajdhani text-base sm:text-lg">
                  <div className="flex items-start">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg mr-3 sm:mr-4 flex-shrink-0">
                      <i className="ri-map-pin-line text-xl sm:text-2xl"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-white mb-1">Address</p>
                      <p className="text-gray-300 text-sm sm:text-base">3227 Northview Dr<br />Elkhart, IN 46514</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg mr-3 sm:mr-4 flex-shrink-0">
                      <i className="ri-phone-line text-xl sm:text-2xl"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-white mb-1">Phone</p>
                      <a href="tel:5742187357" className="text-gray-300 hover:text-neon-purple transition-colors text-sm sm:text-base cursor-pointer">
                        (574) 218-7357
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg mr-3 sm:mr-4 flex-shrink-0">
                      <i className="ri-mail-line text-xl sm:text-2xl"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-white mb-1">Email</p>
                      <a href="mailto:upnsmokevapes@gmail.com" className="text-gray-300 hover:text-neon-purple transition-colors text-sm sm:text-base break-all cursor-pointer">
                        upnsmokevapes@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 sm:p-8 border border-neon-purple/30">
                <h2 className="font-orbitron text-xl sm:text-2xl font-bold text-neon-purple mb-4 sm:mb-6">
                  Follow Us
                </h2>
                <div className="flex space-x-3 sm:space-x-4 mb-4 sm:mb-6">
                  <a
                    href="https://www.facebook.com/people/Up-N-Smoke-Vape-Shop/61584660412472/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
                  </a>
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-neon-purple to-neon-pink rounded-lg hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-instagram-line text-xl sm:text-2xl"></i>
                  </a>
                </div>
                <div className="bg-white p-3 sm:p-4 rounded-lg inline-block">
                  <img
                    src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://www.facebook.com/people/Up-N-Smoke-Vape-Shop/61584660412472/"
                    alt="Facebook QR Code"
                    className="w-24 h-24 sm:w-32 sm:h-32"
                  />
                  <p className="text-xs sm:text-sm text-center text-black mt-2 font-rajdhani font-semibold">
                    Scan to Follow on Facebook
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 sm:p-8 border border-neon-purple/30">
              <h2 className="font-orbitron text-xl sm:text-2xl font-bold text-neon-purple mb-4 sm:mb-6">
                Send Us a Message
              </h2>
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                <div>
                  <label htmlFor="name" className="block font-rajdhani text-sm sm:text-base font-semibold text-white mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 bg-black/50 border border-neon-purple/30 rounded-lg text-white font-rajdhani text-sm focus:outline-none focus:border-neon-purple transition-colors"
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block font-rajdhani text-sm sm:text-base font-semibold text-white mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 bg-black/50 border border-neon-purple/30 rounded-lg text-white font-rajdhani text-sm focus:outline-none focus:border-neon-purple transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block font-rajdhani text-sm sm:text-base font-semibold text-white mb-2">
                    Phone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 bg-black/50 border border-neon-purple/30 rounded-lg text-white font-rajdhani text-sm focus:outline-none focus:border-neon-purple transition-colors"
                    placeholder="(123) 456-7890"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block font-rajdhani text-sm sm:text-base font-semibold text-white mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-4 py-3 bg-black/50 border border-neon-purple/30 rounded-lg text-white font-rajdhani text-sm focus:outline-none focus:border-neon-purple transition-colors resize-none"
                    placeholder="Your message (max 500 characters)"
                  ></textarea>
                  <p className="text-xs text-gray-400 mt-1 font-rajdhani">
                    {formData.message.length}/500 characters
                  </p>
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-neon-purple to-neon-pink rounded-full font-orbitron font-bold text-sm sm:text-base shadow-lg shadow-neon-purple/50 hover:shadow-neon-purple/80 hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
                {submitStatus === 'success' && (
                  <p className="text-green-400 font-rajdhani text-center text-sm sm:text-base">
                    Message sent successfully! We'll get back to you soon.
                  </p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-red-400 font-rajdhani text-center text-sm sm:text-base">
                    Failed to send message. Please try again or call us directly.
                  </p>
                )}
              </form>
            </div>
          </div>

          <div className="mt-12 sm:mt-16 rounded-2xl overflow-hidden border border-neon-purple/30 h-80 sm:h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3004.8!2d-85.9767!3d41.7325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8816c8e8e8e8e8e8%3A0x8e8e8e8e8e8e8e8e!2s3227%20Northview%20Dr%2C%20Elkhart%2C%20IN%2046514!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Up N' Smoke Location"
            ></iframe>
          </div>
        </div>
      </section>

      <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-10 md:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-purple to-neon-pink mb-3 sm:mb-4 px-4">
              Connect on Social Media
            </h2>
            <p className="font-rajdhani text-base sm:text-lg text-gray-300 px-4">
              Stay updated with our latest products and exclusive deals
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-4 sm:p-6 md:p-8 border border-neon-purple/30">
            <div className="aspect-video w-full">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fpeople%2FUp-N-Smoke-Vape-Shop%2F61584660412472%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="100%"
                height="100%"
                style={{ border: 'none', overflow: 'hidden' }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="Facebook Feed"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
